module.exports = __webpack_public_path__ + "favicon-14c27dbc3720993b1b4bb0910894cd6e.svg";